// services/cabinetTilesService.js
import { db } from "../firebase";
import { doc, getDoc, onSnapshot, setDoc } from "firebase/firestore";
import {
  getStorage,
  ref,
  uploadBytesResumable,
  getDownloadURL,
} from "firebase/storage";

const REF = doc(db, "userCabinet", "tiles"); // єдиний конфіг

export function subscribeCabinetTiles(cb) {
  return onSnapshot(REF, (s) => cb(s.exists() ? s.data() : {}));
}
export async function getCabinetTiles() {
  const s = await getDoc(REF);
  return s.exists() ? s.data() : {};
}
export async function saveCabinetTiles(partial) {
  await setDoc(REF, partial, { merge: true });
}

// upload PDF договорів у Storage + запис URL у конфіг
export async function uploadContract(kind, file) {
  const storage = getStorage();
  const r = ref(storage, `contracts/${kind}/${Date.now()}-${file.name}`);
  const task = uploadBytesResumable(r, file);
  return new Promise((resolve, reject) => {
    task.on(
      "state_changed",
      () => {},
      reject,
      async () => {
        const url = await getDownloadURL(task.snapshot.ref);
        await setDoc(
          REF,
          {
            contracts: {
              [kind]: { url, fileName: file.name, uploadedAt: Date.now() },
            },
          },
          { merge: true }
        );
        resolve(url);
      }
    );
  });
}
